(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["article-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.article-share__copy');
    if (!(button instanceof HTMLButtonElement)) return;

    const url = button.dataset.shareUrl || window.location.href;
    const status = button.parentElement?.querySelector('.article-share__status');
    const done = () => {
      if (status) status.textContent = button.dataset.copiedLabel || '';
      button.dataset.copied = 'true';
      window.setTimeout(() => {
        delete button.dataset.copied;
        if (status) status.textContent = '';
      }, 2500);
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(done, () => window.prompt('', url));
    } else {
      window.prompt('', url);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
